<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增字典', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          // stripe: true,  // 斑马纹
          index: true, // 行首 索引
          // translate: false, // 自动去除$字段
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          defaultExpandAll: true, // 展开全部
          column: [
            {
              label: '标题',
              rules: [{
                type: 'string', required: true, message: '请填写标题', trigger: 'blur'
              }],
              prop: 'title',
              row: true,
              width: '150px',
              search: true
            },
            {
              label: '编码',
              rules: [{
                type: 'string', required: true, message: '请填写编码', trigger: 'blur'
              }],
              prop: 'code',
              width: '200px',
              row: true,
            },
            {
              label: '数据',
              prop: 'dynamicList',
              formatter: function (row) {
                let t = '';
                row.dynamic.forEach((item) => {
                  t += item.value + ':' + item.label + ' <br>';
                })
                return t
              },
              headerAlign: 'left',
              align: 'left',
              display: false,
            },
            {
              label: '数据',
              type: 'dynamic',
              prop: 'dynamic',
              span: 24,
              children: {
                column: [
                  {
                    label: '值',
                    type: 'number',
                    width: 200,
                    prop: "value"
                  },
                  {
                    label: '含义',
                    width: 200,
                    prop: "label"
                  }
                ],
              }
            }
          ],
        }
      }
    }
  }
</script>
